import { createSlice } from '@reduxjs/toolkit';

export const updateAlertStatusActionSlice = createSlice({
  name: 'updateAlertStatusActionSlice',
  initialState: {
    changedCount: 0,
  },
  reducers: {
    detectStatusChange: (state) => {
      state.changedCount += 1;
    },
  },
});

export const { detectStatusChange } = updateAlertStatusActionSlice.actions;

export default updateAlertStatusActionSlice.reducer;
